import { Tag } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { PublicEventStatusDto } from "../../autogen/bff-api";
import { useProcurementTerms } from "../terminology/useProcurementTerms";

export type EventStatusInput = { kind: "PUBLIC"; status: PublicEventStatusDto };

interface Props {
  event: EventStatusInput;
  size?: "sm" | "md" | "lg";
}

interface TagMeta {
  color: string;
  text: string;
}

export const EventStatusTag = ({ event, size }: Props) => {
  const { t } = useTranslation();
  const terms = useProcurementTerms();
  const tagMeta = getPublicTagMeta(event.status, t, terms.publishedStatus);

  return (
    <Tag
      variant="outline"
      colorScheme={tagMeta.color}
      size={size}
      textAlign="center"
      paddingTop={"2px"}
      paddingBottom={"2px"}
    >
      {tagMeta.text}
    </Tag>
  );
};

export const publicStatusLabel = (
  status: PublicEventStatusDto,
  t: (k: string) => string,
  publishedLabel: string,
): string => getPublicTagMeta(status, t, publishedLabel).text;

const getPublicTagMeta = (status: PublicEventStatusDto, t: (k: string) => string, publishedLabel: string): TagMeta => {
  switch (status) {
    case PublicEventStatusDto.Draft:
      return { color: "orange", text: t("Draft") };
    case PublicEventStatusDto.PublicationPending:
      return { color: "blue", text: t("Pending publication") };
    case PublicEventStatusDto.Published:
      return { color: "green", text: publishedLabel };
    case PublicEventStatusDto.PublicationFailed:
      return { color: "red", text: t("Publication failed") };
    case PublicEventStatusDto.Evaluation:
      return { color: "purple", text: t("Evaluation") };
    case PublicEventStatusDto.Evaluated:
      return { color: "purple", text: t("Evaluated") };
    case PublicEventStatusDto.AwardDecision:
      return { color: "purple", text: t("Award decision") };
    case PublicEventStatusDto.Awarded:
      return { color: "purple", text: t("Awarded") };
    case PublicEventStatusDto.Cancelled:
      return { color: "gray", text: t("Cancelled_competition") };
    case PublicEventStatusDto.Closed:
      return { color: "blue", text: t("Closed") };
    case PublicEventStatusDto.Completed:
      return { color: "gray", text: t("Completed") };
    default:
      console.warn(`Unknown PublicEventStatusDto value: ${status as string}`);
      return { color: "gray", text: String(status) };
  }
};
